export default class {
  static asArray(x) {
    return Array.isArray(x) ? x : [x];
  }
}
